import { z } from "zod";

export const CategorySchema = z.object({
  id: z.string(),
  title: z.string(),
  type: z.string(),
  isActive: z.boolean(),
  isEditable: z.boolean(),
  createdAt: z.coerce.date(),
  deactivatedAt: z.coerce.date(),
});
export const CategoryArraySchema = z.array(CategorySchema);

export const UserProfileSettingsSchema = z.object({
  profileId: z.string().optional(),
  dateFormat: z.string()
});

export const UserProfileSchema = z.object({
  id: z.string().optional(),
  email: z.string().email(),
  name: z.string(),
  currency: z.string(),
  startingBalance: z.number(),
  userProfileSettings: UserProfileSettingsSchema
});

export const ExpenseSchema = z.object({
  id: z.string(),
  date: z.coerce.date(),
  amount: z.number(),
  description: z.string(),
  category: z.string(),
});
export const ExpenseArraySchema = z.array(ExpenseSchema);

export const IncomeSchema = z.object({
  id: z.string(),
  date: z.coerce.date(),
  amount: z.number(),
  description: z.string(),
  category: z.string(),
});
export const IncomeArraySchema = z.array(IncomeSchema);

export const AllTimeReportsSchema = z.object({
  reportInfo: z.any(), // Keep broad; tighten later as needed
});

export const ReportSchema = z.object({
  reportInfo: z.any(),
});

export function validate<T>(schema: z.ZodType<T>, data: unknown): T {
  const parsed = schema.safeParse(data);
  if (!parsed.success) {
    throw new Error("Response validation failed");
  }
  return parsed.data;
}


